export default __webpack_public_path__ + "static/media/wifi.7236fe3d.svg";